import service from '@/api/emailList';
import {handleError} from '@/state/generators/helpers';
import {alert, changes, loading} from "../../generators/helpers";

export const state = {
    item: {},
    service: service('newsletters/emailLists')
}

export const getters = {}

export const mutations = {

}

export const actions = {
    update: function ({commit, state}, payload) {
        loading(commit)

        const { id, data } = changes(payload, state.item)

        const content = Object.assign({_method: 'PUT'}, data)

        return state.service.update(id, content).then(response => {
            let model = {};

            if (!response.import) {
                model = Object.assign({}, data, response.data);
                commit('REPLACE_ITEM', model);
                commit('SET_ITEM', model);
            } else {
                model = Object.assign({}, data, response.model);
                commit('REPLACE_ITEM', model);
                commit('SET_ITEM', model);
            }

            alert(commit, this.$t('request.save_is_successful'))
            commit('SET_ERRORS', {});
            loading(commit, false)

            return !response.import ? model : response;
        }).catch((e) => {
            handleError(e, commit)
        })
    },

    processImport: function ({commit, state}, {id, data}) {
        loading(commit);

        return state.service.processImport(id, data).then(response => {
            alert(commit, response.message);
            commit('REPLACE_ITEM', response.model);
            commit('SET_ITEM', response.model);
            loading(commit, false);
            return response;
        }).catch((e) => {
            handleError(e, commit)
        })
    },
}
